import { PrintSlices } from "./PrintSlices";

export interface SectionSelectors {
  header?: string;
  breaks: string[];
  breakPosition?: keyof DOMRect;
  footer?: string;
}

export interface IPrintRecord {
  name: string;
  $el: HTMLElement;
  scale?: number;
  selectors?: SectionSelectors;
  canvas?: HTMLCanvasElement;
  slices?: PrintSlices;
}

export interface PrintSection {
  canvas: HTMLCanvasElement;
  width: number;
  height: number;
  page: number;
  position: number;
}
export * from "./PrintPage";
export * from "./PrintSlices";
export * from "./PrintRecord";
